import { Injectable, Injector, Inject } from "@angular/core";
import { AuthService as Auth0Service, AuthClientConfig } from '@auth0/auth0-angular';
import { environment } from "src/environments/environment";

@Injectable({ providedIn: 'root' })
export class Auth0WrapperService {
    private instance: Auth0Service | null = null;

    constructor(private injector: Injector, private authConfig: AuthClientConfig) { }

    getInstance(): Auth0Service {
        if (!this.instance) {
            this.authConfig.set({
                domain: environment.auth0.domain,
                clientId: environment.auth0.clientId,
                authorizationParams: {
                    redirect_uri: `${window.location.origin}/gateway`,
                    scope: 'openid profile name given_name family_name email email_verified identities uid',
                    audience: environment.auth0.audience
                }
            });

            this.instance = this.injector.get(Auth0Service)
        }
        return this.instance;
    }
}